export default {
    "Tipo F": "https://constructoracolpatria.com/recorridos/sanangel79m/ ",
    "Tipo A": "https://constructoracolpatria.com/recorridos/sanangel90m/",
    "Natural": "https://www.celeusgroup.com/natural/",
    "Natural-A": "https://www.celeusgroup.com/natural/",
    "Natural-B": "https://www.celeusgroup.com/natural/",
    "Natural-C": "https://www.celeusgroup.com/natural/",
    "Classic": "https://www.celeusgroup.com/classic/",
    "Delux": "https://www.celeusgroup.com/delux/",
    "Delux-A": "https://www.celeusgroup.com/delux/",
    "Delux-B": "https://www.celeusgroup.com/delux/",
    "Delux-C": "https://www.celeusgroup.com/delux/",
}